import useSWR from 'swr';

import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { fetcher } from './utils';

export interface IMediaItem {
  id: number;
  ratio_description: string;
  image_section: string;
  image_height?: number | null;
  image_width?: number | null;
}

export const useMediaList = (params?: Record<string, any>) => {
  const url = '/v4/dash/simple/custom_image_ratios';

  const { data, isLoading, error, mutate, isValidating } = useSWR<IPaginatedResponse<IMediaItem>>(
    { url, params },
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};

export const useMedia = (id?: number | string | null) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IDetailResponse<IMediaItem>>(
    id ? `/v4/dash/custom_image_ratios/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, error, mutate, isValidating };
};
